window.app = window.app || {};

window.app.article = {
  el: {
    banner: {
      top: document.querySelector('.mt-article-banner--top'),
      sidebar: document.querySelector('.mt-article-banner--sidebar'),
      bottom: document.querySelector('.mt-article-banner--bottom')
    },
    bannerLinks: document.querySelectorAll('.mt-article-banner__action .mt-btn'),
    topBannerWrapper: document.querySelector('.mt-article-banner-wrapper'),
    articleMain: document.querySelector('.mt-article__main'),
    articleContent: document.querySelector('.mt-article__content'),
    articleInner: document.querySelector('.mt-article__inner'),
  },

  init: function () {
    const _this = this;

    // Update --banner-height CSS variable
    const updateBannerHeight = () => {
      if (_this.el.topBannerWrapper && _this.el.banner.top) {
        const bannerHeight = _this.el.banner.top.offsetHeight;
        _this.el.topBannerWrapper.style.setProperty('--banner-height', `${bannerHeight}px`);
      }
    };
    window.addEventListener('resize', updateBannerHeight);
    setTimeout(() => updateBannerHeight(), 1000);

    // Sticky top banner
    const checkTopBanner = () => {
      if (!_this.el.banner.top || !_this.el.topBannerWrapper || !_this.el.articleInner) return;

      const wrapperRect = _this.el.topBannerWrapper.getBoundingClientRect();
      const innerRect = _this.el.articleInner.getBoundingClientRect();
      const wrapperOutOfView = wrapperRect.bottom <= 0;

      let bottomVisible = false;
      if (_this.el.banner.bottom) {
        const bottomRect = _this.el.banner.bottom.getBoundingClientRect();
        bottomVisible = bottomRect.top < window.innerHeight && bottomRect.bottom > 0;
      }

      const innerBottomVisible = innerRect.bottom < window.innerHeight;

      if (bottomVisible || innerBottomVisible) {
        _this.el.banner.top.classList.remove('is-stuck');
      } else if (wrapperOutOfView) {
        _this.el.banner.top.classList.add('is-stuck');
      } else {
        _this.el.banner.top.classList.remove('is-stuck');
      }
    };
    window.addEventListener('scroll', checkTopBanner);
    checkTopBanner();

    // Sidebar banner visibility
    if (_this.el.banner.sidebar) {
      const bannerImages = _this.el.banner.sidebar.querySelectorAll('.mt-article-banner__image');
      if (bannerImages.length > 0) {
        const desktopImage = [...bannerImages].find(image => image.classList.contains('mt-article-banner__image--desktop'));
        desktopImage && desktopImage.remove();
      }
    }

    const checkSidebarBanner = () => {
      if (!_this.el.banner.sidebar || !_this.el.banner.top) return;

      const sidebarRect = _this.el.banner.sidebar.getBoundingClientRect();
      const topRect = _this.el.banner.top.getBoundingClientRect();
      const sidebarVisible = sidebarRect.top < window.innerHeight && sidebarRect.bottom > 0;

      const topVisible = topRect.bottom > 0 && topRect.top < window.innerHeight;
      let bottomVisible = false;

      if (_this.el.banner.bottom) {
        const bottomRect = _this.el.banner.bottom.getBoundingClientRect();
        bottomVisible = bottomRect.bottom > 0 && bottomRect.top < window.innerHeight;
      }

      if (sidebarVisible && !topVisible && !bottomVisible) {
        _this.el.banner.sidebar.classList.add('is-visible');
      } else {
        _this.el.banner.sidebar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', checkSidebarBanner);
    checkSidebarBanner();

    // Event listener for sidebar banner link
    _this.el.bannerLinks.forEach(link => {
      link.addEventListener('click', () => {
        e.preventDefault();
        const banner = link.closest('.mt-article-banner');
        const bannerTitle = banner.querySelector('.mt-article-banner__title')?.innerText || 'Article banner';
        const bannerType = banner.dataset.type;
    
        app.dl.ctaClick(link.innerText, { location: bannerTitle, type: bannerType });
      });
    });
    
  }
};

window.app.article.init();